import styled from "styled-components";
import { Button } from "reactstrap";

export const ButtonsWrap = styled.div`
    .activate{
        background-color: transparent;
        color: green;
        border: none;
        text-transform: capitalize;
        padding: 0px 5px;
        font-size: 14px;
        margin-top: 8px;
        p{
            margin-bottom:0px;
        }
    }
    .inActivate{
        background-color: transparent;
        color: red;
        border: none;
        text-transform: capitalize;
        padding: 0px 5px;
        margin-top: 8px;
        font-size: 14px;
        p{
            margin-bottom:0px;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/component/Doctorlist/styles.js